import { FieldErrors, FieldValues, Path, UseFormReturn } from "react-hook-form";

interface ScrollToFirstErrorOptions<T extends FieldValues> {
  form: UseFormReturn<T>;
  errors: FieldErrors<T>;
  /**
   * Optional offset from the top of the error element when scrolling
   * @default 100
   */
  offset?: number;
  /**
   * Optional container element to scroll within
   * If not provided, will scroll the window
   */
  container?: HTMLElement | null;
  event?: React.BaseSyntheticEvent;
}

export async function onFormInvalid<T extends FieldValues>(
  {
    form,
    errors,
    offset = 100,
    container = null,
    event,
  }: ScrollToFirstErrorOptions<T>
): Promise<boolean> {
  event?.preventDefault();
  event?.stopPropagation();

  // Find the first field with an error
  const firstErrorField = Object.keys(errors)[0] as Path<T>;
  const errorElement = document.querySelector(`[name="${firstErrorField}"]`);

  if (errorElement) {
    if (container) {
      container.addEventListener(
      "scrollend",
      () => form.setFocus(firstErrorField),
      { once: true }
    );
      // Scroll within the container
      container.scrollTo({
        top: errorElement.getBoundingClientRect().top - container.getBoundingClientRect().top - offset,
        behavior: 'smooth'
      });
    } else {
      window.addEventListener(
      "scrollend",
      () => form.setFocus(firstErrorField),
      { once: true }
    );
      // Scroll the window
      errorElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }

  return true;
} 